module.exports = __webpack_public_path__ + "img/statloader.2b0d4053.svg";